var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _g, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect3, _rect4, _circle8, _path129, _rect5, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicprototipos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 397,
    height: 241,
    fill: "none",
    viewBox: "0 0 397 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3324D5",
    d: "M356.039 205.193H0v.178h356.039v-.178Zm-47.568 11.164h-31.944v.178h31.944v-.178Zm-36.628 0h-6.188v.178h6.188v-.178Zm-58.705-2.457h-13.785v.178h13.785v-.178Zm-124.755-.091H57.628v.178h30.755v-.178Zm-37.093 0h-4.507v.178h4.508v-.178Zm150.213-4.215h-66.707v.178h66.707v-.178Z",
    opacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3324D5",
    d: "M153.409 106.996a3.639 3.639 0 1 0 0-7.277 3.639 3.639 0 0 0 0 7.277Z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.834 106.242a3.638 3.638 0 1 0 .001-7.277 3.638 3.638 0 0 0-.001 7.277Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3324D5",
    d: "M219.86 160.225h-19.069v42.29h19.069v-42.29Zm78.657 42.291h-94.058v2.677h94.058v-2.677Zm-71.158-5.213h67.313v-13.872h-67.313v13.872Z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M269.601 189.42h-17.154a.84.84 0 0 0-.841.84v.221c0 .464.377.84.841.84h17.154a.84.84 0 0 0 .84-.84v-.221a.84.84 0 0 0-.84-.84Zm-25.985-35.434a4.2 4.2 0 1 0 0-8.402 4.201 4.201 0 0 0 0 8.402Zm20.294-1.111a4.21 4.21 0 0 1-2.595 3.894 4.213 4.213 0 0 1-4.589-.911 4.209 4.209 0 0 1 2.983-7.184 4.197 4.197 0 0 1 4.201 4.201Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3324D5",
    d: "M97.533 201.625H33.518v3.567h64.015v-3.567Z",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.153 186.729H66.871a1.27 1.27 0 0 1-1.267-1.267 1.268 1.268 0 0 1 1.267-1.261h10.282a1.269 1.269 0 0 1 1.268 1.261 1.268 1.268 0 0 1-1.268 1.267Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M261.092 72.027c-.114 2-.356 3.838-.627 5.746-.27 1.909-.662 3.76-1.075 5.626a53.905 53.905 0 0 1-3.753 11.044 9.346 9.346 0 0 1-2.349 2.891 20.16 20.16 0 0 1-2.535 1.837 40.614 40.614 0 0 1-5.191 2.685 73.7 73.7 0 0 1-10.739 3.653l-.883-2.642a110.542 110.542 0 0 0 4.942-2.307c1.624-.805 3.247-1.617 4.8-2.5a42.772 42.772 0 0 0 4.436-2.798 16.58 16.58 0 0 0 1.851-1.545 4.91 4.91 0 0 0 1.076-1.424 45.105 45.105 0 0 0 1.673-4.878 87.63 87.63 0 0 0 1.232-5.163c.356-1.744.641-3.51.897-5.283.256-1.773.463-3.56.62-5.27l5.625.328Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M257.253 65.341c-2.272.577-3.859 9.927-3.859 9.927l6.259 4.272s6.003-9.428 4.272-11.92c-1.837-2.656-3.354-3.154-6.672-2.279Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M257.253 65.341c-2.272.577-3.859 9.927-3.859 9.927l6.259 4.272s6.003-9.428 4.272-11.92c-1.837-2.656-3.354-3.154-6.672-2.279Z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m257.458 67.398-1.744 9.421 3.518 2.386-1.774-11.807Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m257.458 67.398-1.744 9.421 3.518 2.386-1.774-11.807Z",
    opacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m235.229 102.725-3.91-3.96-.512 5.583s2.926 1.98 4.984.919l-.562-2.542Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m226.72 98.176-.178 4.692 4.265 1.481.513-5.582-4.6-.591Zm42.823 124.45h-5.512l-.37-12.761h5.512l.37 12.761Zm48.628-25.592-4.202 3.567-9.613-8.58 4.202-3.568 9.613 8.581Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m312.823 200.174 4.052-4.665a.431.431 0 0 1 .57-.085l4.151 2.692a.87.87 0 0 1 .373.62.887.887 0 0 1-.216.69c-1.424 1.602-2.229 2.3-4.016 4.351-1.104 1.26-2.585 3.218-4.102 4.984-1.517 1.766-3.325.328-2.848-.534 2.136-3.859 1.623-5.219 1.659-7.121.008-.346.142-.678.377-.932Zm-48.984 21.824h6.195a.445.445 0 0 1 .442.377l.712 4.9a.88.88 0 0 1-.883.975c-2.136 0-3.204-.164-5.924-.164-1.674 0-5.142.178-7.449.178-2.307 0-2.442-2.293-1.474-2.499 4.315-.926 6.017-2.207 7.47-3.432.257-.212.578-.33.911-.335Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "m263.661 209.871.192 6.58h5.512l-.185-6.58h-5.519Zm44.904-21.418-4.202 3.568 4.956 4.422 4.202-3.568-4.956-4.422Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M257.252 65.341s-2.62.926 2.635 33.261h22.38c-.377-9.107-.384-14.726 3.967-33.425a65.751 65.751 0 0 0-9.5-1.26 70.138 70.138 0 0 0-10.168 0c-4.365.384-9.314 1.424-9.314 1.424Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M257.252 65.341s-2.62.926 2.635 33.261h22.38c-.377-9.107-.384-14.726 3.967-33.425a65.751 65.751 0 0 0-9.5-1.26 70.138 70.138 0 0 0-10.168 0c-4.365.384-9.314 1.424-9.314 1.424Z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m269.878 66.237 2.022 4.13s8.481-2.591 7.37-6.323l-2.848-.327-6.544 2.52Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m269.878 66.237 2.022 4.13s8.481-2.591 7.37-6.323l-2.848-.327-6.544 2.52Z",
    opacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m269.722 65.853-2.849 4.216s-6.038-2.62-1.872-6.146l1.773-.206 2.948 2.136Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m269.722 65.853-2.849 4.216s-6.038-2.62-1.872-6.146l1.773-.206 2.948 2.136Z",
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M278.815 35.434c2.614-2.514.107-14.327 6.986-10.418 8.744 4.985 14.391-1.538 11.471-4.016 6.139.434 5.54 7.42 2.984 11.172-6.487 9.55-19.575.47-19.653 5.32-.079 4.849-1.788-2.058-1.788-2.058Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M275.041 33.732c2.998-2.371 13.238-.399 6.216 9.15l-6.216-9.15Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M275.041 33.732c2.998-2.371 13.238-.399 6.216 9.15l-6.216-9.15Z",
    opacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M276.622 38.168c8.731 1.303 9.343 15.488-4.208 17.688l4.208-17.688Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M275.724 52.459c-.641 3.268-1.282 9.257 1.011 11.443 0 0-.897 3.311-6.971 3.311-6.68 0-3.198-3.31-3.198-3.31 3.646-.877 3.561-3.561 2.92-6.118l6.238-5.326Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "m273.182 54.66-3.696 3.148c.163.591.268 1.197.314 1.808 1.424-.206 3.311-1.737 3.46-3.19a4.858 4.858 0 0 0-.078-1.766Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M261.945 48.67c-3.012-3.88-6.935-13.892 4.807-14.854l-4.807 14.854Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M275.505 44.115c.712 5.426 1.139 7.704-1.026 10.98-3.254 4.935-10.075 4.643-12.397-.456-2.1-4.586-2.926-12.682 1.894-15.843a7.464 7.464 0 0 1 11.529 5.319Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M259.909 98.574s-4.344 42.447-3.988 59.252c.378 17.482 6.786 57.351 6.786 57.351h7.449s-1.182-38.851-.52-56.012c.712-18.721 6.665-60.59 6.665-60.59h-16.392Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M259.909 98.574s-4.344 42.447-3.988 59.252c.378 17.482 6.786 57.351 6.786 57.351h7.449s-1.182-38.851-.52-56.012c.712-18.721 6.665-60.59 6.665-60.59h-16.392Z",
    opacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M270.784 215.44h-8.745l-.641-2.784 9.792-.342-.406 3.126Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M270.784 215.44h-8.745l-.641-2.784 9.792-.342-.406 3.126Z",
    opacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M269.544 109.134c-5.497 11.058-1.103 31.231.841 38.737.996-11.273 2.677-25.051 3.987-35.17-.833-5.725-2.293-8.666-4.828-3.567Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M269.544 109.134c-5.497 11.058-1.103 31.231.841 38.737.996-11.273 2.677-25.051 3.987-35.17-.833-5.725-2.293-8.666-4.828-3.567Z",
    opacity: 0.4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M265.798 98.573s5.07 44.149 8.901 58.298c4.543 16.826 32.755 39.463 32.755 39.463l5.733-4.871s-20.465-24.588-23.94-33.467c-7.42-18.913-1.069-47.097-7-59.437l-16.449.014Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M265.798 98.573s5.07 44.149 8.901 58.298c4.543 16.826 32.755 39.463 32.755 39.463l5.733-4.871s-20.465-24.588-23.94-33.467c-7.42-18.913-1.069-47.097-7-59.437l-16.449.014Z",
    opacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m314.119 191.207-7.107 6.032-2.649-1.588 8.033-7.477 1.723 3.033Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m314.119 191.207-7.107 6.032-2.649-1.588 8.033-7.477 1.723 3.033Z",
    opacity: 0.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M267.671 47.21c.086.435-.078.834-.363.89-.285.058-.584-.256-.669-.711-.086-.456.078-.833.363-.89.285-.057.584.27.669.712Zm-4.913.97c.085.434-.078.833-.363.89-.285.056-.584-.257-.67-.712-.085-.456.072-.834.356-.89.285-.058.577.27.677.711Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m262.202 47.488-1.111-.1s.698.713 1.111.1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "M264.182 48.672a12.006 12.006 0 0 1-1.004 3.09 1.921 1.921 0 0 0 1.609 0l-.605-3.09Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M266.647 53.164a.128.128 0 0 1-.128-.128.128.128 0 0 1 .128-.129A3.519 3.519 0 0 0 269.196 51a.132.132 0 0 1 .242 0c.006.015.01.032.01.05a.124.124 0 0 1-.01.05 3.718 3.718 0 0 1-2.741 2.065h-.05Zm-4.602-12.447s4.636 7.028 13.181 7.954c0 0 8.822-8.011 3.396-13.565-8.787-8.987-19.269 2.464-16.577 5.611Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M277.361 48.31a3.932 3.932 0 0 1-1.239 2.784c-1.025.96-2.179.199-2.435-1.104-.228-1.175 0-3.084 1.317-3.56a1.794 1.794 0 0 1 2.357 1.88Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M268.796 45.332a.272.272 0 0 1-.178-.064 2.083 2.083 0 0 0-1.809-.534.253.253 0 0 1-.276-.092.264.264 0 0 1 .141-.413 2.59 2.59 0 0 1 2.293.648.263.263 0 0 1 0 .37.256.256 0 0 1-.171.085Zm-8.787 1.018a.228.228 0 0 1-.1 0 .25.25 0 0 1-.086-.055.25.25 0 0 1-.078-.186.25.25 0 0 1 .022-.1 2.585 2.585 0 0 1 1.787-1.574.249.249 0 0 1 .299.207.252.252 0 0 1-.038.197.252.252 0 0 1-.169.109 2.09 2.09 0 0 0-1.424 1.26.259.259 0 0 1-.213.142Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M294.089 92.634v-.633c0-.855-.121-1.674-.207-2.5a61.85 61.85 0 0 0-2.036-9.449 85.34 85.34 0 0 0-3.19-9.015l-5.248 2.136a160.947 160.947 0 0 1 2.983 8.495 86.725 86.725 0 0 1 1.225 4.273c.363 1.424.712 2.848.961 4.272l.15.947a21.851 21.851 0 0 1-1.51-.555c-2.691-1.097-5.44-2.52-8.153-3.888l-1.574 2.3a51.862 51.862 0 0 0 7.776 5.583c.741.429 1.51.81 2.3 1.14.444.191.901.35 1.367.476.278.079.562.138.848.178.38.049.766.049 1.146 0a3.451 3.451 0 0 0 1.738-.655 3.347 3.347 0 0 0 1.26-1.915c.108-.388.163-.788.164-1.19Zm-3.831-1.06h.128c.078-.008-.021.007-.164 0h.036Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M286.256 65.148c2.243.712 4.934 8.403 4.934 8.403l-8.694 6.223s-3.176-6.444-2.229-9.342c.954-3.02 3.411-6.06 5.989-5.284Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M286.256 65.148c2.243.712 4.934 8.403 4.934 8.403l-8.694 6.223s-3.176-6.444-2.229-9.342c.954-3.02 3.411-6.06 5.989-5.284Z",
    opacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M311.314 202.829a.757.757 0 0 1-.584-.299.44.44 0 0 1-.1-.434c.2-.676 2.137-1.225 2.329-1.282a.147.147 0 0 1 .078 0 .14.14 0 0 1 .064.043.138.138 0 0 1 .019.071c0 .025-.006.05-.019.071-.341.648-1.025 1.745-1.716 1.83h-.071Zm1.424-1.673c-.762.242-1.744.662-1.851 1.018a.168.168 0 0 0 .05.185.47.47 0 0 0 .193.163.471.471 0 0 0 .248.044c.363-.043.862-.563 1.353-1.41h.007Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M312.126 201.177a2.248 2.248 0 0 1-1.595-.449.448.448 0 0 1 0-.57.709.709 0 0 1 .491-.299c.783-.092 1.994.933 2.044.983a.12.12 0 0 1 .04.054.118.118 0 0 1 .002.067.116.116 0 0 1-.028.063.128.128 0 0 1-.057.037 3.09 3.09 0 0 1-.897.114Zm-.969-1.068h-.085a.434.434 0 0 0-.313.192c-.093.135-.057.214 0 .263.235.307 1.317.42 1.979.307a3.338 3.338 0 0 0-1.559-.762h-.022Zm-49.382 22.842a2.063 2.063 0 0 1-1.339-.341.718.718 0 0 1-.235-.634.432.432 0 0 1 .221-.349c.676-.363 2.848.755 3.119.883a.129.129 0 0 1 .056.057.132.132 0 0 1 .015.078.122.122 0 0 1-.1.107 8.902 8.902 0 0 1-1.737.199Zm-.983-1.139a.474.474 0 0 0-.242.05.15.15 0 0 0-.085.135.447.447 0 0 0 .149.42c.335.299 1.239.356 2.464.15a7.114 7.114 0 0 0-2.286-.755Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M263.469 222.76h-.056c-.656-.299-1.952-1.481-1.852-2.136 0-.15.128-.335.491-.37a.911.911 0 0 1 .713.227c.712.577.826 2.058.826 2.137a.128.128 0 0 1-.008.064.127.127 0 0 1-.042.05.117.117 0 0 1-.072.028Zm-1.31-2.236h-.078c-.242 0-.256.114-.264.15-.057.37.819 1.31 1.489 1.716a2.963 2.963 0 0 0-.712-1.702.714.714 0 0 0-.421-.164h-.014Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m279.847 87.352-1.851-5.66-2.948 4.763s1.737 3.084 4.03 3.034l.769-2.137Zm-5.717-8.239-2.25 4.123 3.147 3.219 2.948-4.764-3.845-2.578Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m267.13 46.522-1.104-.1s.698.712 1.104.1Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m282.602 97.256.577 2.008c.078.15-.107.314-.37.314H259.78c-.206 0-.37-.1-.384-.228l-.2-1.966c0-.142.157-.256.378-.256h22.665a.406.406 0 0 1 .363.128Z",
    opacity: 0.6
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M279.562 99.79h.605c.122 0 .214-.063.207-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607c.007.07.114.135.235.135Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.562 99.79h.605c.122 0 .214-.063.207-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607c.007.07.114.135.235.135Z",
    opacity: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M261.483 99.79h.605c.121 0 .214-.063.207-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607c.007.07.086.135.235.135Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M261.483 99.79h.605c.121 0 .214-.063.207-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607c.007.07.086.135.235.135Z",
    opacity: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M270.519 99.79h.613c.121 0 .213-.063.199-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607a.23.23 0 0 0 .235.135Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M270.519 99.79h.613c.121 0 .213-.063.199-.134l-.285-2.607c0-.078-.114-.135-.235-.135h-.605c-.121 0-.214.057-.207.135l.285 2.607a.23.23 0 0 0 .235.135Z",
    opacity: 0.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M199.098 229.29h47.104a7.879 7.879 0 0 0 7.543-5.309 7.88 7.88 0 0 0 .404-3.235l-11.265-161.1a9.339 9.339 0 0 0-9.143-8.546h-47.104a7.882 7.882 0 0 0-7.947 8.545l11.265 161.108a9.338 9.338 0 0 0 9.143 8.537Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#A286FA",
    d: "M199.098 229.29h47.104a7.879 7.879 0 0 0 7.543-5.309 7.88 7.88 0 0 0 .404-3.235l-11.265-161.1a9.339 9.339 0 0 0-9.143-8.546h-47.104a7.882 7.882 0 0 0-7.947 8.545l11.265 161.108a9.338 9.338 0 0 0 9.143 8.537Z",
    opacity: 0.58
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M192.931 229.29h47.097a7.879 7.879 0 0 0 7.543-5.309 7.88 7.88 0 0 0 .404-3.235l-11.265-161.1a9.339 9.339 0 0 0-9.143-8.546H180.47a7.882 7.882 0 0 0-7.947 8.545l11.265 161.101a9.336 9.336 0 0 0 9.143 8.544Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M192.931 229.29h47.097a7.879 7.879 0 0 0 7.543-5.309 7.88 7.88 0 0 0 .404-3.235l-11.265-161.1a9.339 9.339 0 0 0-9.143-8.546H180.47a7.882 7.882 0 0 0-7.947 8.545l11.265 161.101a9.336 9.336 0 0 0 9.143 8.544Z",
    opacity: 0.79
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M201.676 102.413h8.716a1.43 1.43 0 0 0 1.41-.976c.065-.195.086-.401.064-.605l-2.087-29.836a1.719 1.719 0 0 0-1.695-1.581h-8.701a1.422 1.422 0 0 0-1.467 1.58l2.086 29.837c.035.423.226.819.534 1.111a1.73 1.73 0 0 0 1.14.47Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M201.676 102.413h8.716a1.43 1.43 0 0 0 1.41-.976c.065-.195.086-.401.064-.605l-2.087-29.836a1.719 1.719 0 0 0-1.695-1.581h-8.701a1.422 1.422 0 0 0-1.467 1.58l2.086 29.837c.035.423.226.819.534 1.111a1.73 1.73 0 0 0 1.14.47Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M148.289 229.289h-47.104a7.897 7.897 0 0 1-5.865-2.514 7.885 7.885 0 0 1-2.082-6.031l11.265-161.1a9.346 9.346 0 0 1 9.143-8.546h47.104a7.884 7.884 0 0 1 7.947 8.545l-11.265 161.101a9.34 9.34 0 0 1-9.143 8.545Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#A286FA",
    d: "M148.289 229.289h-47.104a7.897 7.897 0 0 1-5.865-2.514 7.885 7.885 0 0 1-2.082-6.031l11.265-161.1a9.346 9.346 0 0 1 9.143-8.546h47.104a7.884 7.884 0 0 1 7.947 8.545l-11.265 161.101a9.34 9.34 0 0 1-9.143 8.545Z",
    opacity: 0.7
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M142.116 229.289H95.02a7.896 7.896 0 0 1-5.865-2.514 7.887 7.887 0 0 1-2.082-6.031l11.265-161.1a9.334 9.334 0 0 1 9.143-8.546h47.097a7.884 7.884 0 0 1 7.947 8.545L151.26 220.744a9.34 9.34 0 0 1-9.144 8.545Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.116 229.289H95.02a7.896 7.896 0 0 1-5.865-2.514 7.887 7.887 0 0 1-2.082-6.031l11.265-161.1a9.334 9.334 0 0 1 9.143-8.546h47.097a7.884 7.884 0 0 1 7.947 8.545L151.26 220.744a9.34 9.34 0 0 1-9.144 8.545Z",
    opacity: 0.8
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M149.179 220.017H87.164a1.094 1.094 0 0 1-1.082-1.161L97.054 61.921a1.09 1.09 0 0 1 1.089-1.01h62.008a1.09 1.09 0 0 1 1.089 1.16l-10.994 156.935a1.085 1.085 0 0 1-1.068 1.011Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.179 220.017H87.164a1.094 1.094 0 0 1-1.082-1.161L97.054 61.921a1.09 1.09 0 0 1 1.089-1.01h62.008a1.09 1.09 0 0 1 1.089 1.16l-10.994 156.935a1.085 1.085 0 0 1-1.068 1.011Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M147.67 76.977h-40.253a4.423 4.423 0 0 0-4.33 4.044l-4.194 59.957a3.73 3.73 0 0 0 3.767 4.045h2.791l-1.424 4.393a12.615 12.615 0 0 0 8.481-4.393h30.406a4.423 4.423 0 0 0 4.329-4.045l4.194-59.957a3.724 3.724 0 0 0-.194-1.531 3.724 3.724 0 0 0-2.059-2.211 3.735 3.735 0 0 0-1.514-.302Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0F4FD",
    d: "M147.67 76.977h-40.253a4.423 4.423 0 0 0-4.33 4.044l-4.194 59.957a3.73 3.73 0 0 0 3.767 4.045h2.791l-1.424 4.393a12.615 12.615 0 0 0 8.481-4.393h30.406a4.423 4.423 0 0 0 4.329-4.045l4.194-59.957a3.724 3.724 0 0 0-.194-1.531 3.724 3.724 0 0 0-2.059-2.211 3.735 3.735 0 0 0-1.514-.302Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M101.826 157.092h40.254a3.724 3.724 0 0 1 2.779 1.188 3.728 3.728 0 0 1 .988 2.857l-1.801 25.756a4.424 4.424 0 0 1-4.33 4.044h-2.798l.783 4.394a10.828 10.828 0 0 1-7.833-4.394h-30.42a3.722 3.722 0 0 1-2.78-1.188 3.73 3.73 0 0 1-.987-2.856l1.802-25.756a4.425 4.425 0 0 1 4.343-4.045Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.826 157.092h40.254a3.724 3.724 0 0 1 2.779 1.188 3.728 3.728 0 0 1 .988 2.857l-1.801 25.756a4.424 4.424 0 0 1-4.33 4.044h-2.798l.783 4.394a10.828 10.828 0 0 1-7.833-4.394h-30.42a3.722 3.722 0 0 1-2.78-1.188 3.73 3.73 0 0 1-.987-2.856l1.802-25.756a4.425 4.425 0 0 1 4.343-4.045Z",
    opacity: 0.91
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M138.178 55.606a1.459 1.459 0 0 1-1.424 1.346 1.243 1.243 0 0 1-.926-.395 1.234 1.234 0 0 1-.327-.951 1.47 1.47 0 0 1 1.424-1.346 1.243 1.243 0 0 1 .925.394 1.23 1.23 0 0 1 .328.951Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M138.178 55.606a1.459 1.459 0 0 1-1.424 1.346 1.243 1.243 0 0 1-.926-.395 1.234 1.234 0 0 1-.327-.951 1.47 1.47 0 0 1 1.424-1.346 1.243 1.243 0 0 1 .925.394 1.23 1.23 0 0 1 .328.951Z",
    opacity: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M131.242 56.952h-9.392a1.246 1.246 0 0 1-1.253-1.346 1.462 1.462 0 0 1 1.424-1.346h9.392a1.25 1.25 0 0 1 .923.397 1.247 1.247 0 0 1 .33.949 1.462 1.462 0 0 1-1.424 1.346Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.242 56.952h-9.392a1.246 1.246 0 0 1-1.253-1.346 1.462 1.462 0 0 1 1.424-1.346h9.392a1.25 1.25 0 0 1 .923.397 1.247 1.247 0 0 1 .33.949 1.462 1.462 0 0 1-1.424 1.346Z",
    opacity: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m81.097 87.893 1.119 2.186c.391.712.79 1.488 1.203 2.221a108.688 108.688 0 0 0 2.55 4.351 54.987 54.987 0 0 0 5.767 7.876c.534.534 1.11 1.175 1.481 1.467.517.417 1.07.789 1.652 1.11a29.303 29.303 0 0 0 4.315 1.852 87.589 87.589 0 0 0 9.763 2.627l-.228 3.924c-3.708.217-7.429 0-11.087-.648a28.816 28.816 0 0 1-5.697-1.602 16.063 16.063 0 0 1-2.92-1.531 12.192 12.192 0 0 1-1.352-1.047l-1.125-.99a50.543 50.543 0 0 1-7.192-8.744 66.07 66.07 0 0 1-2.898-4.721 80.101 80.101 0 0 1-1.31-2.435 56.942 56.942 0 0 1-1.24-2.543l7.2-3.353Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m107.523 111.584 3.168-2.236 1.674 6.465s-2.792.983-4.892-.434l.05-3.795Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m115.065 107.879 1.125 5.412-3.831 2.52-1.673-6.465 4.379-1.467Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m135.194 102.147-.862-.156a5.88 5.88 0 0 0-2.698.163l-2.486.755a14.953 14.953 0 0 0 1.368-8.445c-.299-2.179-1.937-1.68-1.937-1.68s-2.4 9.057-7.385 12.532l-1.566 1.09 2.236 15.957 1.844-.171h7.377a5.133 5.133 0 0 0 3.917-2.093 10.866 10.866 0 0 0 2.186-6.096l.47-7.427c.114-2.193-.94-4.165-2.464-4.429Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m135.194 102.147-.862-.156a5.88 5.88 0 0 0-2.698.163l-2.486.755a14.953 14.953 0 0 0 1.368-8.445c-.299-2.179-1.937-1.68-1.937-1.68s-2.4 9.057-7.385 12.532l-1.566 1.09 2.236 15.957 1.844-.171h7.377a5.133 5.133 0 0 0 3.917-2.093 10.866 10.866 0 0 0 2.186-6.096l.47-7.427c.114-2.193-.94-4.165-2.464-4.429Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "m114.942 126.067 7.022-1.531c.548-.114.932-.869.847-1.674l-1.83-18.279c-.086-.804-.598-1.36-1.147-1.246l-7.021 1.531c-.548.114-.932.869-.847 1.673l1.83 18.279c.085.805.598 1.361 1.146 1.247Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M101.413 65.81c-.086.412.064.79.334.847.271.057.563-.228.648-.641.086-.413-.064-.798-.334-.855-.271-.057-.563.235-.648.648Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "M101.441 66.594a15.17 15.17 0 0 0 1.232 3.945 2.404 2.404 0 0 1-2.044-.043l.812-3.902Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M102.539 63.282a.248.248 0 0 1-.135-.043 1.97 1.97 0 0 0-1.788-.043.248.248 0 0 1-.334-.312.232.232 0 0 1 .054-.082.234.234 0 0 1 .081-.054 2.448 2.448 0 0 1 2.257.078.243.243 0 0 1 .109.253.228.228 0 0 1-.038.089.243.243 0 0 1-.206.114Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M86.758 67.135c.712 3.824 1.496 10.838-1.182 13.387 0 0 1.047 3.888 8.16 3.888 7.833 0 3.732-3.888 3.732-3.888-4.273-1.018-4.151-4.18-3.411-7.12l-7.299-6.267Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M84.495 81.618c-.513-1.253-.428-3.56-.05-3.596 1.48-.1 9.385-.121 11.998.883a2.735 2.735 0 0 1 1.773 3.468l-13.721-.755ZM67.027 224.846a6.616 6.616 0 0 1-1.367-.149.112.112 0 0 1-.06-.032.113.113 0 0 1-.032-.061.14.14 0 0 1 .008-.07.137.137 0 0 1 .042-.058c.064-.043 1.51-1.025 2.271-.854a.58.58 0 0 1 .392.291.51.51 0 0 1 0 .591 1.674 1.674 0 0 1-1.254.342Zm-1.018-.327c.783.128 1.852.128 2.08-.171 0 0 .085-.114 0-.314a.331.331 0 0 0-.228-.17 3.357 3.357 0 0 0-1.852.669v-.014Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M65.688 224.717h-.064a.112.112 0 0 1-.046-.049.112.112 0 0 1-.01-.065c0-.064.127-1.574.711-2.072a.71.71 0 0 1 .535-.157.406.406 0 0 1 .391.327c.107.584-.94 1.724-1.474 2.023l-.043-.007Zm1.054-2.137a.436.436 0 0 0-.277.107 2.904 2.904 0 0 0-.62 1.638c.534-.406 1.204-1.267 1.14-1.616 0 0 0-.107-.186-.129h-.057Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M59.65 224.589h5.233l4.821-12.112h-5.227l-4.828 12.112Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M65.297 223.984h-5.875a.464.464 0 0 0-.448.364l-1.033 4.649a.77.77 0 0 0 .769.926c2.05-.035 3.048-.157 5.633-.157 1.587 0 4.863.171 7.063.171 2.2 0 2.478-2.136 1.581-2.371-4.03-.883-5.547-2.101-6.836-3.254a1.267 1.267 0 0 0-.854-.328Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M107.886 85.613a544.267 544.267 0 0 1 4.614 8.66l4.543 8.679 1.14 2.137c.241.517.527 1.013.854 1.481a10.116 10.116 0 0 0 2.849 2.371 39.556 39.556 0 0 0 8.331 3.56l-.442 3.903c-.893.018-1.787-.01-2.677-.086a25.498 25.498 0 0 1-2.642-.306 24.988 24.988 0 0 1-5.291-1.424 15.544 15.544 0 0 1-5.226-3.269 13.928 13.928 0 0 1-1.958-2.563l-1.339-2.136a266.048 266.048 0 0 1-5.063-8.588 245.805 245.805 0 0 1-4.685-8.773l6.992-3.646Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M72.305 84.858c-2.137 4.565 4.692 18.977 4.692 18.977l11.664-5.411a83.539 83.539 0 0 0-4.743-11.92c-3.047-6.046-9.449-6.31-11.614-1.646Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.305 84.858c-2.137 4.565 4.692 18.977 4.692 18.977l11.664-5.411a83.539 83.539 0 0 0-4.743-11.92c-3.047-6.046-9.449-6.31-11.614-1.646Z",
    opacity: 0.8
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m78.562 85.791-2.634 15.63a77.1 77.1 0 0 0 1.068 2.414l11.664-5.412s-5.27-9.107-10.098-12.632Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m78.562 85.791-2.634 15.63a77.1 77.1 0 0 0 1.068 2.414l11.664-5.412s-5.27-9.107-10.098-12.632Z",
    opacity: 0.7
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M105.515 81.975s5.568 6.295.313 45.217H77.851c-.2-4.272 2.5-25.243-1.638-45.487a73.03 73.03 0 0 1 9.364-1.182c3.96-.228 7.93-.228 11.891 0a53.3 53.3 0 0 1 8.047 1.452Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.515 81.975s5.568 6.295.313 45.217H77.851c-.2-4.272 2.5-25.243-1.638-45.487a73.03 73.03 0 0 1 9.364-1.182c3.96-.228 7.93-.228 11.891 0a53.3 53.3 0 0 1 8.047 1.452Z",
    opacity: 0.8
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m107.773 91.238-4.323 10.681 4.323 6.288c.427-5.648.427-11.32 0-16.969Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m107.773 91.238-4.323 10.681 4.323 6.288c.427-5.648.427-11.32 0-16.969Z",
    opacity: 0.7
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M98.706 85.427c-1.723 4.7 5.198 18.956 5.198 18.956l12.533-6.316a64.009 64.009 0 0 0-6.138-12.198c-3.753-5.483-9.699-5.576-11.593-.442Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.706 85.427c-1.723 4.7 5.198 18.956 5.198 18.956l12.533-6.316a64.009 64.009 0 0 0-6.138-12.198c-3.753-5.483-9.699-5.576-11.593-.442Z",
    opacity: 0.8
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m129.178 112.686 5.127-2.051 1.424 6.181s-4.073 1.474-7.036-.67l.485-3.46Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "m139.958 110.699-.791 5.526-3.446.591-1.417-6.181 5.654.064Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "M64.472 212.484h5.234l-3.468 8.702-4.843-.983 3.077-7.719Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M87.82 62.066c-.712 5.134-1.424 8.103.577 11.243 3.04 4.721 9.784 3.703 12.049-1.11 2.043-4.33 2.919-12.006-1.624-15.061a7.121 7.121 0 0 0-11.002 4.928Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M107.558 53.434c-4.429-4.094-.926-5.134-.926-5.134s-4.856-2.008-2.934 2.293c2.685 5.996-4.835 4.151-8.438 0-2.222-2.563-8.068.064-7.783 2.564.285 2.499-8.9.562-4.742 6.017.078 5.696 2.293 11.236 5.233 12.739 5.042 2.57 8.823-4.622 10.233-10.382 7.605 3.653 13.942-3.86 9.357-8.097Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M94.356 64.962a5.925 5.925 0 0 0 1.29 3.56c1.075 1.31 2.3.592 2.584-.925.257-1.367 0-3.696-1.353-4.458s-2.528.27-2.52 1.823Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M82.785 53.84a9.628 9.628 0 0 1 6.323 2.059s-1.288-5.512-6.323-2.058Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M93.575 127.191s1.046 21.192 4.913 39.877c1.232 5.917.427 12.255-3.04 17.204-10.19 14.533-26.348 33.887-26.348 33.887l-8.466-.947s13.707-25.414 20.728-38.039c1.595-2.848 3.005-5.454 1.802-8.545-11.628-29.515-5.34-43.437-5.34-43.437h15.75Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M93.575 127.191s1.046 21.192 4.913 39.877c1.232 5.917.427 12.255-3.04 17.204-10.19 14.533-26.348 33.887-26.348 33.887l-8.466-.947s13.707-25.414 20.728-38.039c1.595-2.848 3.005-5.454 1.802-8.545-11.628-29.515-5.34-43.437-5.34-43.437h15.75Z",
    opacity: 0.3
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m95.147 145.506-8.103-9.67c-.306 4.336 2.314 20.558 11.3 30.527-1.43-7.028-2.463-14.441-3.197-20.857Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m95.147 145.506-8.103-9.67c-.306 4.336 2.314 20.558 11.3 30.527-1.43-7.028-2.463-14.441-3.197-20.857Z",
    opacity: 0.4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m71.484 216.871-1.659 3.432-10.204-2.62.812-3.183 11.051 2.371Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m71.484 216.871-1.659 3.432-10.204-2.62.812-3.183 11.051 2.371Z",
    opacity: 0.1
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3D3",
    d: "M101.89 224.589h5.226l1.531-12.112h-5.226l-1.531 12.112Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M109.411 224.845c-.54 0-1.079-.05-1.609-.149a.12.12 0 0 1-.1-.1.122.122 0 0 1 .011-.075.123.123 0 0 1 .053-.053c.078-.043 1.901-1.083 2.777-.848a.61.61 0 0 1 .392.292.47.47 0 0 1 0 .542c-.207.313-.855.391-1.524.391Zm-1.211-.327c.983.135 2.308.114 2.543-.214 0-.043.064-.114 0-.271a.361.361 0 0 0-.243-.17c-.562-.136-1.659.341-2.264.669l-.036-.014Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M107.822 224.717a.142.142 0 0 1-.071 0 .152.152 0 0 1-.038-.052.132.132 0 0 1-.012-.062c0-.064.15-1.474.812-2.016a.9.9 0 0 1 .712-.213c.342.035.434.206.456.349.1.591-1.154 1.723-1.78 2.001l-.079-.007Zm1.282-2.137a.648.648 0 0 0-.434.164 2.93 2.93 0 0 0-.712 1.609c.648-.384 1.495-1.274 1.424-1.63 0 0 0-.114-.242-.143h-.036Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "M107.266 223.984h-5.697a.448.448 0 0 0-.441.364l-1.04 4.649a.755.755 0 0 0 .154.646.761.761 0 0 0 .601.28c2.065-.036 5.041-.157 7.626-.157 3.034 0 5.647.171 9.2.171 2.137 0 2.742-2.136 1.845-2.371-4.095-.897-7.434-.99-10.974-3.169a2.377 2.377 0 0 0-1.274-.413Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AD8C",
    d: "M103.422 212.484h5.233l-1.125 8.823-5.127-.79 1.019-8.033Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "M105.827 127.191s4.38 14.641 11.614 33.468c2.357 6.124 3.269 12.02 1.631 17.204-5.077 16.093-9.463 40.296-9.463 40.296l-8.723-.947s-.335-24.687 2.755-37.412c1.588-6.53 1.047-8.908-.584-11.066-22.216-29.558-16.25-41.521-16.25-41.521l19.02-.022Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M105.827 127.191s4.38 14.641 11.614 33.468c2.357 6.124 3.269 12.02 1.631 17.204-5.077 16.093-9.463 40.296-9.463 40.296l-8.723-.947s-.335-24.687 2.755-37.412c1.588-6.53 1.047-8.908-.584-11.066-22.216-29.558-16.25-41.521-16.25-41.521l19.02-.022Z",
    opacity: 0.3
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A3AFF",
    d: "m111.119 216.678-.456 3.475-10.296-1.745-.306-3.176 11.058 1.446Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#27266A",
    d: "m111.119 216.678-.456 3.475-10.296-1.745-.306-3.176 11.058 1.446Z",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.644,
    height: 79.846,
    x: 322.602,
    y: 52.369,
    fill: "red",
    fillOpacity: 0.01,
    rx: 5.793,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.17,
    height: 79.372,
    x: 322.839,
    y: 52.606,
    stroke: "#A286FA",
    strokeWidth: 0.474,
    rx: 5.556,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.373,
    height: 82.11,
    x: 321.237,
    y: 51.237,
    fill: "#fff",
    stroke: "#6F4EF6",
    strokeWidth: 0.474,
    rx: 5.556
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56.145,
    height: 13.349,
    x: 328.35,
    y: 107.943,
    fill: "#F2F1FF",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    rx: 1.862
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 340.036,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.498,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.959,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.422,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.884,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.347,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.807,
    cy: 114.618,
    r: 1.283,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    opacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 33.121,
    height: 4.044,
    x: 339.863,
    y: 91.469,
    fill: "#A286FA",
    stroke: "#A286FA",
    strokeWidth: 0.094,
    rx: 2.022
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 48.671,
    height: 4.044,
    x: 332.086,
    y: 98.09,
    fill: "#6F4EF6",
    stroke: "#A286FA",
    strokeWidth: 0.094,
    opacity: 0.5,
    rx: 2.022
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.422,
    cy: 75.686,
    r: 12.393,
    fill: "#F2F1FF",
    stroke: "#6F4EF6",
    strokeWidth: 0.414
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    stroke: "#A286FA",
    strokeWidth: 0.414,
    d: "M358.189 75.245a3.169 3.169 0 0 1-4.932-2.637 3.173 3.173 0 0 1 1.957-2.93 3.17 3.17 0 0 1 2.975 5.567Zm4.038 6.389a.247.247 0 0 1 .009.108.249.249 0 0 1-.04.099.24.24 0 0 1-.187.092h-11.165a.235.235 0 0 1-.189-.097.245.245 0 0 1-.041-.1.222.222 0 0 1 .009-.109 6.112 6.112 0 0 1 5.805-4.205 6.12 6.12 0 0 1 5.799 4.212Z",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    x: 16,
    y: 13,
    fill: "#F2F1FF",
    rx: 9.778
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#A286FA",
    d: "M46.556 41.722H29.445a3.666 3.666 0 0 1-3.667-3.666v-9.778a3.667 3.667 0 0 1 3.667-3.667h17.111a3.667 3.667 0 0 1 3.667 3.667v9.778a3.666 3.666 0 0 1-3.667 3.666Z",
    opacity: 0.35
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M42.279 41.723h-8.556a1.834 1.834 0 0 0 0 3.666h8.556a1.834 1.834 0 0 0 0-3.666Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A286FA",
    d: "M36 59.5v26c0 12.703 10.297 23 23 23h20M362 139v80.5c0 11.598-9.402 21-21 21H225c-6.351 0-11.5-5.149-11.5-11.5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEAFD",
    d: "M197.469 9A12.47 12.47 0 0 1 185 21.469a12.47 12.47 0 0 1 12.469 12.468 12.466 12.466 0 0 1 12.469-12.468A12.468 12.468 0 0 1 197.469 9Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M179.469 0A12.47 12.47 0 0 1 167 12.469a12.47 12.47 0 0 1 12.469 12.469 12.466 12.466 0 0 1 12.469-12.47A12.469 12.469 0 0 1 179.469 0Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A286FA",
    d: "M80.566 15.469a12.97 12.97 0 0 0 8.903-8.903 12.969 12.969 0 0 0 8.902 8.903 12.97 12.97 0 0 0-8.902 8.902 12.97 12.97 0 0 0-8.903-8.902Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#A286FA",
    d: "m357 144 5-8 5 8h-10ZM31 65l5-8 5 8H31Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 79.231,
    height: 91.432,
    x: 316.808,
    y: 48.231,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.897
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.127552 0 0 0 0 0.123438 0 0 0 0 0.329167 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_18518"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_18518",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicprototipos);
export default __webpack_public_path__ + "static/media/graphic prototipos.ea3e4804b1b1a4878d28551fa0d4edfe.svg";
export { ForwardRef as ReactComponent };